import { Box, Container } from "@mui/material";
import React, { useContext, useState } from "react";
import { PageTitle } from "../../commanComponents/PageTitle";
import { LinearProgressBar } from "../../commanComponents/LinearProgressBar";
import { String } from "../../constants/Strings";
import { AddDependantText } from "../../commanComponents/AddDependantText";
import ACRButton from "../../commanComponents/ACRButton";
import { getColor } from "../../style/color/color";
import { useNavigate } from "react-router-dom";
import { DependantQuestionCard } from "../../commanComponents/DependantQuestionCard";
import { DataContext } from "../../Hooks/context/ChildData";
import CustomSnackbar from "../../commanComponents/CustomerSnackbar";

const DependantQuestion = () => {
  const [addQuestionCard, setAddQuestionCard] = useState([0]);
  const [dependants, setDependants] = useState([{ name: "", age: "" }]);
  const [errorMessage, setErrorMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const { collectData } = useContext(DataContext);

  const navigation = useNavigate();
  const onHandleClick = () => {
    setAddQuestionCard([...addQuestionCard, addQuestionCard.length]);
  };
  const onDeleteClick = (index) => {
    setAddQuestionCard(addQuestionCard.filter((_, i) => i !== index));
  };
  const handleDependantChange = (index, field, value) => {
    const updatedDependants = [...dependants];
    if (!updatedDependants[index]) {
      return;
    }
    updatedDependants[index][field] = field === "age" ? Number(value) : value;

    setDependants(updatedDependants);
  };
  const handleContineuClick = () => {
    const hasError = dependants.some(
      (dependant) => !dependant.name || !dependant.age
    );
    if (hasError) {
      setErrorMessage(String.ChildPlannig.dependantFeilds);
      setSnackbarOpen(true);
      return;
    }
    collectData({ dependants: dependants });
    navigation(String.navigations.retirementgoal);
  };
  //render
  return (
    <Box
      sx={{
        height: "100vh",
      }}
    >
      <Container sx={{ flexGrow: 1 }}>
        <PageTitle PageTitle={String.ChildPlannig.Title} />
        <LinearProgressBar
          dragMessage={String.ChildPlannig.dragMessage}
          progress={38}
          progressNumber={38}
          stepNumber={2}
        />
        <Box sx={{ width: "100%", textAlign: "center" }}>
          {addQuestionCard.map((_, index) => (
            <DependantQuestionCard
              key={index}
              question={"What is your dependant age?"}
              placeholder={`Your ${index + 1} dependant age`}
              totalAge={dependants[index]?.age || 0}
              minAge={"01"}
              maxAge={"100"}
              isVisible={true}
              onDeleteClick={() => {
                onDeleteClick(index);
              }}
              onDepandantAgeChange={(value) => {
                handleDependantChange(index, "age", value);
              }}
              onDependantNameChange={(e) => {
                handleDependantChange(index, "name", e.target.value);
              }}
            ></DependantQuestionCard>
          ))}

          <AddDependantText
            label={"+ Add dependant"}
            onClickHandle={onHandleClick}
          />
        </Box>

        <Box sx={{ display: "flex", justifyContent: "center", mt: "50px" }}>
          <ACRButton
            label={String.continue}
            style={{
              width: "100%",
              maxWidth: "350px",
              backgroundColor: getColor.primaryOrange,
              color: getColor.PrimaryWhite,
              borderRadius: "40px",
              p: "10px",
              height: "60px",
              mb: "40px",
              lineHeight: "22.2px",
              fontWeight: 700,
              fontSize: "16px",
              textAlign: "center",
              textTransform: "initial",
            }}
            onClickButton={handleContineuClick}
          />
        </Box>
        <CustomSnackbar
          open={snackbarOpen}
          handleClose={() => {
            setSnackbarOpen(false);
          }}
          message={errorMessage}
          severity={"error"}
        />
      </Container>
    </Box>
  );
};

export default DependantQuestion;
